import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled
        ? 'bg-white/98 backdrop-blur-xl border-b border-stone-200'
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 cursor-pointer group">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-amber-700 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
              <i className="ri-heart-pulse-fill text-white text-lg"></i>
            </div>
            <div>
              <div className={`text-base font-bold leading-tight transition-colors duration-300 ${isScrolled ? 'text-slate-900' : 'text-white'}`}>
                Celebrity Home Health<span className="text-amber-500">™</span>
              </div>
              <div className={`text-xs font-medium transition-colors duration-300 ${isScrolled ? 'text-amber-600' : 'text-amber-300'}`}>
                Medicare Certified · ACHC Accredited · Las Vegas, NV
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {[
              { href: '/', label: 'Home' },
              { href: '/about', label: 'About' },
              { href: '/services', label: 'Services' },
              { href: '/contact', label: 'Contact' },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-slate-700 hover:text-amber-700 hover:bg-amber-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://ats.rippling.com/celebrityhh/jobs"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                isScrolled
                  ? 'text-slate-700 hover:text-amber-700 hover:bg-amber-50'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              Careers <i className="ri-external-link-line text-xs opacity-60"></i>
            </a>
            <a
              href="/contact"
              className="ml-3 px-5 py-2.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              866-939-0330
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
              isScrolled ? 'text-slate-900 hover:bg-stone-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200">
          <nav className="flex flex-col px-6 py-4 space-y-1">
            {[
              { href: '/', label: 'Home' },
              { href: '/about', label: 'About' },
              { href: '/services', label: 'Services' },
              { href: '/contact', label: 'Contact' },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-4 py-3 text-slate-700 hover:text-amber-700 hover:bg-amber-50 rounded-lg font-medium transition-all duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://ats.rippling.com/celebrityhh/jobs"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-3 text-slate-700 hover:text-amber-700 hover:bg-amber-50 rounded-lg font-medium transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              Careers &amp; Jobs <i className="ri-external-link-line text-xs"></i>
            </a>
            <a
              href="/contact"
              className="mt-2 px-5 py-3 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold text-center transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Request Care · 866-939-0330
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
